import { render, staticRenderFns } from "./basePrice.vue?vue&type=template&id=4a896b3e&scoped=true&"
import script from "./basePrice.vue?vue&type=script&lang=js&"
export * from "./basePrice.vue?vue&type=script&lang=js&"
import style0 from "./basePrice.vue?vue&type=style&index=0&id=4a896b3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a896b3e",
  null
  
)

export default component.exports